// extracted by mini-css-extract-plugin
export var dropdownIcon = "_s3-6";
export var imgContainer = "_s3-3";
export var menuIcon = "_s3-5";
export var pillWrapper = "_s3-2";
export var pillsContainer = "_s3-1";
export var subscriptionCard = "_s3-0";
export var subscriptionLogo = "_s3-4";